export enum THEME {
  DARK = 'DARK',
  WHITE = 'WHITE',
}
